import { IconBaseProps } from '@vertex-protocol/web-ui';

export function EthLogoIcon(props: IconBaseProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 8 13.1"
      {...props}
    >
      <g>
        <g id="Layer_1">
          <path fill="currentColor" d="M4,9.8v3.3l4-5.6-4,2.4Z" />
          <path fill="currentColor" d="M4,0l4,6.7-4,2.4L0,6.7" />
          <path fill="currentColor" d="M4,0v4.8L0,6.7M0,7.4l4,2.4v3.3" />
          <path fill="currentColor" d="M4,4.8v4.2l4-2.4" />
          <path fill="currentColor" d="M0,6.7l4-1.8v4.2" />
        </g>
      </g>
    </svg>
  );
}
